import { render, staticRenderFns } from "./InvocationTime.vue?vue&type=template&id=55af85f6&"
import script from "./InvocationTime.vue?vue&type=script&lang=js&"
export * from "./InvocationTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports